import { components } from 'react-select';
import { Box } from '@chakra-ui/react';

export const NoOptionsMessage = (props) => {
  const searchTerm = props?.selectProps?.inputValue;
  const searchTermLen = searchTerm.length;
  return (
    <components.NoOptionsMessage {...props}>
      <Box
        fontSize="14px"
        borderColor="border-color"
        color="secondary-700"
        textAlign="left"
      >
        {searchTermLen < 2
          ? 'Please type 2 or more letters'
          : props?.selectProps?.emptyOptionsMessage ?? 'No results'}
      </Box>
    </components.NoOptionsMessage>
  );
};
